<template>
    <textarea
        ref="description"
        :value="value"
        @input="input"
        @blur="blur"
        class="textarea textarea-block font-size-16 md:font-size-20"
    >
    </textarea>
</template>

<script>
export default {
    name: 'XTextarea',

    props: {
        value: {},

        resizeable: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.updateHeight()
        })
    },

    methods: {
        input(e) {
            this.updateHeight()
            this.$emit('input', e)
        },

        blur(e) {
            this.$emit('blur', e)
        },

        updateHeight() {
            if (!this.resizeable) {
                return
            }

            const textareaLine = this.$refs.description.value.split(/\r\n|\r|\n/).length
            let areaH = window.innerWidth <= 767 ? 50 : 57.59
            let padding = 25.6

            if (textareaLine !== 1) {
                areaH = areaH + (areaH - padding) * (textareaLine - 1)
            }

            this.$refs.description.style.height = `${areaH}px`
        }
    }
}
</script>

<style lang="scss" scoped>
textarea {
    border: none;
    border-radius: 4px;
    color: #463e3c;
    min-height: 80px;

    &::placeholder {
        text-transform: none;
    }
}
</style>
